import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-checkbox-dialog',
  templateUrl: './checkbox-dialog.component.html',
  styleUrls: ['./checkbox-dialog.component.scss']
})
export class CheckboxDialogComponent extends DialogContentBase implements OnInit {

  constructor( public dialog: DialogRef,
    private fb:UntypedFormBuilder) {   super(dialog);  }

  @Input() caption:string;
  @Input() checkedValue:Date;
  form: UntypedFormGroup;

  ngOnInit(): void {

    this.form = this.getForm();
  }

  confirm(){
    const result = this.form.controls['checkedValue'].value;
        this.dialog.close({ text: 'OK' , checkedValue: result});
  }

  cancel() {
    this.dialog.close({ text: 'Cancel' });
  }

  getForm( ) {
    return this.fb.group({
      checkedValue: [this.checkedValue, Validators.required],
    });
  }
}
